export default __webpack_public_path__ + "assets/images/06708156e42c9a7a5f3a5390250e930b.svg";